import { useEffect, useMemo, useState } from "react";

// Redux
import { useSelector } from "react-redux";

// Context
import { OEMContext } from "@DataPages/context/oem/OEMContext";

// Components
import PageLayer from "@Layouts/views/PageLayer";
import MyOEMDataLayer from "@DataPages/components/MyOEM/MyOEMDataLayer";
import CarBrands from "@DataPages/components/MyOEM/CarBrands";

// Icons
import oemIcon from "@/assets/icons/dataPages/oem/oem-icon.svg";

export default function MyOEMDataView() {
	const location = useSelector((state) => state.location.location);
	const [franchise, setFranchise] = useState("");
	const value = useMemo(() => ({ franchise, setFranchise }), [franchise]);

	useEffect(() => {
		setFranchise(location?.franchises?.[0]);

		return () => {
			setFranchise("");
		};
	}, [location]);

	return (
		<OEMContext.Provider value={value}>
			<PageLayer title="My OEM Data" icon={oemIcon} headerSideComponent={<CarBrands />}>
				<MyOEMDataLayer />
			</PageLayer>
		</OEMContext.Provider>
	);
}
